// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skip-link {
  position: fixed;
  top: -60px;
  left: 16px;
  z-index: 1600;
  padding: 12px 20px;
  background: var(--panel-primary, #64d9ed);
  color: var(--panel-primary-contrast, #061b24);
  border-radius: 8px;
  font-weight: 700;
}

.skip-link:focus {
  top: 12px;
}

.page-content > .MuiContainer-root {
  padding-left: 0;
  padding-right: 0;
}

.login-shell {
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  padding: 16px;
  background: #090c14;
}

.login-story {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: 42px 48px;
  border: 1px solid #28334b;
  border-radius: 16px;
  background: #101624;
  isolation: isolate;
}

.login-story::before {
  content: '';
  position: absolute;
  left: 48px;
  top: 0;
  width: 100px;
  height: 1px;
  background: #64d9ed;
  box-shadow: 0 0 18px 2px #64d9ed55;
}

.brand-mark {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid #64d9ed66;
  border-radius: 10px;
  background: #64d9ed0d;
  color: #64d9ed;
  box-shadow: inset 0 0 12px #64d9ed08, 0 0 18px #64d9ed0c;
}

.login-story-copy {
  position: relative;
  z-index: 1;
  padding: 72px 0;
}

.login-headline.MuiTypography-root {
  margin-top: 22px;
  font-size: clamp(58px, 6.6vw, 104px);
  line-height: 0.99;
  font-weight: 750;
  letter-spacing: -0.065em;
}

.login-headline > span {
  text-shadow: 0 0 32px #64d9ed20;
}

.login-orbit {
  position: absolute;
  z-index: -1;
  right: -240px;
  bottom: 105px;
  width: 520px;
  height: 520px;
  border: 1px solid #64d9ed55;
  border-radius: 50%;
  transform: rotate(-28deg);
  box-shadow: 0 0 36px #64d9ed08, inset 0 0 36px #64d9ed08;
}

.login-orbit div {
  position: absolute;
  inset: 50px;
  border: 1px solid #ae94f950;
  border-radius: 50%;
  box-shadow: 0 0 24px #ae94f909;
}

.login-orbit div:nth-child(2) {
  inset: 100px;
  border-color: #64d9ed40;
}

.login-orbit div:nth-child(3) {
  inset: 150px;
  background: #ae94f908;
}

.login-orbit span {
  position: absolute;
  top: 248px;
  left: -7px;
  width: 14px;
  height: 14px;
  background: #64d9ed;
  border: 4px solid #101624;
  border-radius: 50%;
  box-sizing: content-box;
  box-shadow: 0 0 20px #64d9ed55;
}

.login-form-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 48px 20px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--panel-text, #e7edf7);
  box-shadow: 0 0 0 1000px var(--panel-input, #0e131e) inset;
  caret-color: var(--panel-primary, #64d9ed);
}

@media (max-width: 1100px) {
  .login-story {
    padding: 32px;
  }

  .login-form-panel {
    padding: 32px;
  }

  .login-orbit {
    right: -360px;
  }
}

@media (max-width: 700px) {
  .login-shell {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .login-story {
    padding: 22px;
    min-height: 88px;
  }

  .login-story-copy,
  .login-orbit,
  .login-story > :last-child {
    display: none;
  }

  .login-form-panel {
    padding: 28px 16px 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,mDAAmD;EACnD,0DAA0D;EAC1D,0CAA0C;AAC5C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF","sourcesContent":[".skip-link {\n  position: fixed;\n  top: -60px;\n  left: 16px;\n  z-index: 1600;\n  padding: 12px 20px;\n  background: var(--panel-primary, #64d9ed);\n  color: var(--panel-primary-contrast, #061b24);\n  border-radius: 8px;\n  font-weight: 700;\n}\n\n.skip-link:focus {\n  top: 12px;\n}\n\n.page-content > .MuiContainer-root {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.login-shell {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: grid;\n  grid-template-columns: 1.1fr 1fr;\n  padding: 16px;\n  background: #090c14;\n}\n\n.login-story {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: 42px 48px;\n  border: 1px solid #28334b;\n  border-radius: 16px;\n  background: #101624;\n  isolation: isolate;\n}\n\n.login-story::before {\n  content: '';\n  position: absolute;\n  left: 48px;\n  top: 0;\n  width: 100px;\n  height: 1px;\n  background: #64d9ed;\n  box-shadow: 0 0 18px 2px #64d9ed55;\n}\n\n.brand-mark {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #64d9ed66;\n  border-radius: 10px;\n  background: #64d9ed0d;\n  color: #64d9ed;\n  box-shadow: inset 0 0 12px #64d9ed08, 0 0 18px #64d9ed0c;\n}\n\n.login-story-copy {\n  position: relative;\n  z-index: 1;\n  padding: 72px 0;\n}\n\n.login-headline.MuiTypography-root {\n  margin-top: 22px;\n  font-size: clamp(58px, 6.6vw, 104px);\n  line-height: 0.99;\n  font-weight: 750;\n  letter-spacing: -0.065em;\n}\n\n.login-headline > span {\n  text-shadow: 0 0 32px #64d9ed20;\n}\n\n.login-orbit {\n  position: absolute;\n  z-index: -1;\n  right: -240px;\n  bottom: 105px;\n  width: 520px;\n  height: 520px;\n  border: 1px solid #64d9ed55;\n  border-radius: 50%;\n  transform: rotate(-28deg);\n  box-shadow: 0 0 36px #64d9ed08, inset 0 0 36px #64d9ed08;\n}\n\n.login-orbit div {\n  position: absolute;\n  inset: 50px;\n  border: 1px solid #ae94f950;\n  border-radius: 50%;\n  box-shadow: 0 0 24px #ae94f909;\n}\n\n.login-orbit div:nth-child(2) {\n  inset: 100px;\n  border-color: #64d9ed40;\n}\n\n.login-orbit div:nth-child(3) {\n  inset: 150px;\n  background: #ae94f908;\n}\n\n.login-orbit span {\n  position: absolute;\n  top: 248px;\n  left: -7px;\n  width: 14px;\n  height: 14px;\n  background: #64d9ed;\n  border: 4px solid #101624;\n  border-radius: 50%;\n  box-sizing: content-box;\n  box-shadow: 0 0 20px #64d9ed55;\n}\n\n.login-form-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 48px 20px;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--panel-text, #e7edf7);\n  box-shadow: 0 0 0 1000px var(--panel-input, #0e131e) inset;\n  caret-color: var(--panel-primary, #64d9ed);\n}\n\n@media (max-width: 1100px) {\n  .login-story {\n    padding: 32px;\n  }\n\n  .login-form-panel {\n    padding: 32px;\n  }\n\n  .login-orbit {\n    right: -360px;\n  }\n}\n\n@media (max-width: 700px) {\n  .login-shell {\n    grid-template-columns: 1fr;\n    padding: 12px;\n  }\n\n  .login-story {\n    padding: 22px;\n    min-height: 88px;\n  }\n\n  .login-story-copy,\n  .login-orbit,\n  .login-story > :last-child {\n    display: none;\n  }\n\n  .login-form-panel {\n    padding: 28px 16px 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
